import { render, staticRenderFns } from "./ManifestFields.vue?vue&type=template&id=06a1ff77&"
import script from "./ManifestFields.vue?vue&type=script&lang=js&"
export * from "./ManifestFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports